import { useTranslation } from "react-i18next"
import { Typography } from "@mui/material"

import type { FC } from "react"
import type { InstalledOnInfo } from "types/device.types"
import type { Span } from "types/spans.types"

import { getSpanDisplayName } from "helpers/utils/spans"
import EntityLink from "widgets/common/EntityLink"

interface InstalledOnParentLinkProps {
  installedOn: InstalledOnInfo
  /** Fetched by the caller, because while it loads the line beside this waits too. */
  span: Span | undefined
}

/** The asset an installed device is clamped to: its tower, or its span. */
const InstalledOnParentLink: FC<InstalledOnParentLinkProps> = ({ installedOn, span }) => {
  const { t } = useTranslation()
  const { type, spanId, tower, powerline } = installedOn

  if (type === "tower" && tower) {
    return <EntityLink entity="tower" id={tower.id} name={tower.name} maxLines={1} />
  }

  if (type === "span" && spanId) {
    return (
      <EntityLink
        entity="span"
        id={spanId}
        name={getSpanDisplayName(
          { id: spanId, name: span?.name ?? null },
          powerline?.span_ids,
          t,
        )}
        maxLines={1}
      />
    )
  }

  return <Typography variant="body2">-</Typography>
}

export default InstalledOnParentLink
